import {z} from 'zod';
import {createFileRoute, redirect} from '@tanstack/react-router';
import SignInPage from '../pages/SignInPage';

export const Route = createFileRoute('/sign-in')({
  validateSearch: z.object({
    redirect: z.string().optional(),
  }),
  beforeLoad({context, search}) {
    if (context.auth.isAuthenticated) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing redirects
      throw redirect({to: search.redirect ?? '/'});
    }
  },
  component: SignInPage,
});
